import { useState, useEffect } from 'react';
import axios from 'axios';
import { trackException } from '../utils/appInsights';

export const useFetchCommodityPrice = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCommodityPrice = async () => {
    const url = `/api/Commodity`;

    try {
      setLoading(true);

      const { data } = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setData(data);
    } catch (err) {
      console.error('[Commodity Hook] Failed request:', err);
      setError(err);
      trackException(err, 3, {
        url,
        reason: 'Failed to fetch commodity price',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommodityPrice();
  }, []);

  return { data, loading, error };
};
